<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content my-1">
                <b-button variant="outline-primary" size="sm" @click="statOpen = !statOpen">
                    <i class="fa fa-fw" :class="statOpen ? 'fa-chevron-up' : 'fa-chart-line'"></i>
                    {{ $t('label.sith.sap.sithMesSapHandleRecord.stat.toggle') }}
                </b-button>
                <b-collapse v-model="statOpen" class="mt-2" @shown="onStatShown">
                    <div class="card">
                        <div class="card-body">
                            <!-- 懒加载: 首次展开才 mount, 之后保持实例避免重复请求 -->
                            <sap-handle-record-stat-panel v-if="statLoaded"
                                                          ref="statPanel"></sap-handle-record-stat-panel>
                        </div>
                    </div>
                </b-collapse>
            </div>
            <div id="sithMesSapHandleRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"></em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author Shi Wen Long
    // Date 2021-10-18 14:50:22

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import SapHandleRecordStatPanel from "@/components/SithMes/sap/SapHandleRecordStatPanel";

    export default {
        name: "sithMesSapHandleRecordListView",
        components: {SapHandleRecordStatPanel},
        mixins: [emCommonListMixin, emCustomVuexMixin],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                statOpen: false,
                statLoaded: false
            };
        },
        watch: {
            statOpen(opened) {
                // 首次展开才创建面板; 之后收起再展开不重新请求
                if (opened) {
                    this.statLoaded = true;
                }
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            // 折叠动画期间容器没有尺寸, echarts 建不出来, 展开完成后补一次
            onStatShown() {
                if (this.$refs.statPanel) {
                    this.$refs.statPanel.resizeCharts();
                }
            }
        }
    };
</script>
